module.exports = {"2":[403,366,367,368,369,370,371,21,22,23,24,25,26,195,196,197,198,199],"4":[403,366,367,368,369,370,371,21,22,23,24,25,26,195,196,197,198,199],"6":[550,551,403,366,367,368,369,370,195,196,197,198,199,974],"7":[698,656,349,74,256,306,673,195],"30":[698,403,349,673,674,675,256,306],"31":[403,74,349,673,674,675,676,21,22,23,24]}


//////////////////
// WEBPACK FOOTER
// ./src/components/grid/event/toggled-outcomes.json
// module id = 666
// module chunks = 7